document.addEventListener("DOMContentLoaded", function() {

    const data = {
        //DOM Elements
        appContainer: null,
        atcButton: null,
        configuratorsWrapper: [],
        requireSelectContainer: null,
        productForm: null,
        priceTable: null,
        openConfigurator: null,
        bottomBar: null,
        errors: [],
        //Data
        selectedProducts: [],
        configuratorGroupDataFinal: [],
        currentProduct: null,
        popupMap: {}, //Popup objects mapped by sku or generated unique id
        sectionCountMap: {}, //Section data, min, max, products_container, countNumber mapped by unique id
        productMap: {},
        variantenbilderMap: {},
        containerTitleMap: {},
        pdpPriceElement: null
    }

    //First function to run
    function main() {
        setupStateData();

        render();

        setupDynamicData();

        setupEventListeners();

        checkRequiredSelects(true);
        
        // Initialize PDP price with base product price
        updatePdpPrice(data.currentProduct.price);
        
        // Initialize bottom bar price with base product price
        initializeBottomBarPrice();
    }

    function setupStateData() {
        data.appContainer = document.querySelector("#configurator-rahmen");
        data.openConfigurator = document.querySelector("#openConfigurator");
        data.atcButton = document.querySelector("#MainPaymentContainer #AddToCart");
        data.configuratorGroupDataFinal = mergeContainers(configuratorGroupDataFinal);
        data.productForm = document.querySelector(".shopify-product-form[we-form]");
        data.requireSelectContainer = document.querySelector(".we-conf-missing-container");
        data.atcButton.classList.add("we-conf-disabled");
        data.currentProduct = currentProduct;
        data.pdpPriceElement = document.querySelector(".price.price--large");
    }


    function setupDynamicData(){
        const configuratorsWrapper = data.appContainer.querySelectorAll(".we-configurator-wrapper");
        data.configuratorsWrapper = Array.from(configuratorsWrapper);
        data.priceTable = document.querySelector(".we-conf-price-table");
    }

    function render(){
        const initialHTML = getConfiguratorsHTML();
        const bottomBar = createBottomBar();
        data.bottomBar = bottomBar;
        document.body.appendChild(bottomBar);
        if(data.errors.length === 0){
            data.appContainer.appendChild(initialHTML);
            return;
        }
        data.openConfigurator.classList.add("we-hide");
        const errorHTML = getErrorHTML();
        data.appContainer.appendChild(errorHTML);

    }

    function setupEventListeners() {
        data.configuratorsWrapper.forEach(configuratorWrapper => {
            configuratorWrapper.addEventListener("click", (e) => {
                const title = configuratorWrapper.querySelector(".we-configurator-title");
                if (title.contains(e.target)) {
                    toggleConfigurator(configuratorWrapper);
                    checkAllWrappersClosed();
                }
            });
        });

        const productItemsNodes = document.querySelectorAll(".we-product-item");

        Array.from(productItemsNodes).forEach(productItem => {
            productItem.addEventListener("click", (e) => {
                e.stopPropagation();
                handleProductItemClick(productItem);
                checkRequiredSelects();
                updatePriceTable();
            });
        });

        const showMoreLinksNodes = document.querySelectorAll(".we-show-more-link");
        Array.from(showMoreLinksNodes).forEach(showMoreLink => {
            showMoreLink.addEventListener("click", (e) => {
                e.stopPropagation();
                handleShowMoreLinkClick(showMoreLink);
            });
        });

        data.atcButton.addEventListener("click", (e) => {
            handleAtcButtonClick();
        });

        data.bottomBar.querySelector(".we-bottom-bar-atc-button").addEventListener("click", (e) => {
            handleAtcButtonClick();
        });

        const cartDrawer = document.querySelector('#mini-cart');
        data.productForm.addEventListener('submit', (e) => {
            e.preventDefault();
            document.addEventListener('cart:refresh', () => {
                if (cartDrawer) {
                    cartDrawer.open = true;
                }
            }, { once: true });
        });

        data.openConfigurator.addEventListener("click", (e) => {
            const allConfiguratorWrappers = document.querySelectorAll(".we-configurator-wrapper")
            allConfiguratorWrappers.forEach(configuratorWrapper => {
                const firstNestedWrapper = configuratorWrapper.querySelector(".we-nested-wrapper");
                const getPlusButton = configuratorWrapper.querySelector(".we-configurator-title svg path:nth-child(2)");
                getPlusButton.style.transform = "rotate(90deg)";
                firstNestedWrapper.classList.add("grow");
            });
            data.openConfigurator.classList.add("we-config-btn-disabled");
        });

        // Add event listener for anchor tags in requireSelectContainer
        data.requireSelectContainer.addEventListener("click", (e) => {
            if (e.target.tagName === "A") {
                e.preventDefault();
                const href = e.target.getAttribute("href");
                if (href && href.startsWith("#")) {
                    const targetId = href.substring(1);
                    const targetElement = document.getElementById(targetId);
                    if (targetElement) {
                        // Find the first .we-nested-wrapper within the target element
                        const firstNestedWrapper = targetElement.querySelector(".we-nested-wrapper");
                        if (firstNestedWrapper) {
                            // Add grow class to open the container
                            firstNestedWrapper.classList.add("grow");
                            
                            // Update the plus button rotation
                            const getPlusButton = targetElement.querySelector(".we-configurator-title svg path:nth-child(2)");
                            if (getPlusButton) {
                                getPlusButton.style.transform = "rotate(90deg)";
                            }
                        }
                        
                        // Scroll to the target element
                        const targetRect = targetElement.getBoundingClientRect();
                        const targetOffset = targetRect.top - 100 + window.scrollY;
                        window.scrollTo({
                            top: targetOffset,
                            behavior: 'smooth'
                        });
                    }
                }
            }
        });
    }

    function checkRequiredSelects(initial=false){
        const errors = [];

        const notNestedProductsContainers = Array.from(document.querySelectorAll(".we-no-nested"));
        notNestedProductsContainers.forEach(container => {
            const count = container.querySelectorAll(":scope > .we-product-item[data-selected]").length;
            const min = container.getAttribute("data-min");
            if(!min) return;
            if(count < parseInt(min)){
                errors.push(container.getAttribute("data-container-title"));
            }
        })


        const nestedProductsContainers = Array.from(document.querySelectorAll(".we-nested-wrapper[open] .we-products-container"));
        nestedProductsContainers.forEach(container => {
            const count = container.querySelectorAll(":scope > .we-product-item[data-selected]").length;
            if(count < parseInt(container.getAttribute("data-min"))){
                errors.push(container.getAttribute("data-container-title"));
            }
        })
        
        if(errors.length > 0 && !initial){
            data.requireSelectContainer.classList.remove("we-hide");
            const ul = data.requireSelectContainer.querySelector("ul");
            ul.innerHTML = "";
            errors.forEach(error => {
                const li = document.createElement("li");
                const a = document.createElement("a");
                a.href = `#${data.containerTitleMap[error]}`;
                a.textContent = error;
                li.appendChild(a);
                ul.appendChild(li);
            })
            data.atcButton.classList.add("we-conf-disabled");
            data.bottomBar.querySelector(".we-bottom-bar-atc-button").classList.add("we-conf-disabled");
            return;
        }
        if(initial && errors.length > 0){
            return;
        }
        data.requireSelectContainer.classList.add("we-hide");
        data.atcButton.classList.remove("we-conf-disabled");
        data.bottomBar.querySelector(".we-bottom-bar-atc-button").classList.remove("we-conf-disabled");
    }

    function checkAllWrappersClosed(){
        const allConfiguratorWrappers = document.querySelectorAll(".we-nested-wrapper.grow");
        if(allConfiguratorWrappers.length <= 0){
            data.openConfigurator.classList.remove("we-config-btn-disabled");
        }
    }

    function getConfiguratorsHTML(){
        const configuratorContainer = document.createElement("div");
        configuratorContainer.classList.add("we-configurator-container");
        for (let i = 0; i < data.configuratorGroupDataFinal.length; i++) {

            const groupData = data.configuratorGroupDataFinal[i];

            const configuratorWrapper = document.createElement("div");
            configuratorWrapper.classList.add("we-configurator-wrapper");
            configuratorWrapper.setAttribute("id", `we-config-${groupData.handle || groupData.title.replace(" - ","-").replace(" ","-").toLowerCase()}`);
            data.containerTitleMap[groupData.title] = `we-config-${groupData.handle || groupData.title.replace(" - ","-").replace(" ","-").toLowerCase()}`;
            const title = document.createElement("h2");
            title.classList.add("we-configurator-title");
            title.textContent = groupData.container || groupData.title;
            title.innerHTML += getSvgHTML()
            configuratorWrapper.appendChild(title);

            const innerDataContainer = document.createElement("div");
            innerDataContainer.classList.add("we-nested-wrapper");
            innerDataContainer.setAttribute("id", `we-config-inner-${groupData.handle}`);

            const noNested = true;

            if(!groupData.nestedProducts){
                fillProducts(groupData,innerDataContainer,null,noNested);

                configuratorWrapper.appendChild(innerDataContainer);
                configuratorContainer.appendChild(configuratorWrapper);
            } else {
                const nestedElement = document.createElement("div");
                nestedElement.classList.add("we-nested-wrapper-container");
                nestedElement.classList.add("no-nested");
                groupData.nestedProducts.forEach((nestedProduct, index) => {
                    data.containerTitleMap[groupData.items[index].title] = `we-config-${groupData.items[index].handle || (groupData.items[index].title || groupData.items[index].container).replace(" - ","-").replace(" ","-").toLowerCase()}`;
                    fillProducts(groupData.items[index],nestedElement,null,noNested);
                });
                innerDataContainer.appendChild(nestedElement);
                configuratorWrapper.appendChild(innerDataContainer);
                configuratorContainer.appendChild(configuratorWrapper);
            }

        }

        const renderPriceTableHTML = renderPriceTable();
        configuratorContainer.appendChild(renderPriceTableHTML);

        return configuratorContainer;
    }

    function updatePriceTable(){
        const priceTableBody = data.priceTable.querySelector(".we-conf-price-table-body");
        priceTableBody.innerHTML = "";
        const alreadyAdded = new Map();
        let index = 0;
        const containerPrio = new Map();
        data.selectedProducts.forEach(item => {
            const skuElement = data.appContainer.querySelector(`[data-key="${item.key}"]`) || data.appContainer.querySelector(`[nested-id="${item.key}"]`);
            if(!skuElement) return;
            const container = skuElement.closest(".we-products-container");
            containerPrio.set(container,index);
            index++;
        });

        data.selectedProducts.sort((a,b) => {
            const skuElementA = data.appContainer.querySelector(`[data-key="${a.key}"]`) || data.appContainer.querySelector(`[nested-id="${a.key}"]`);
            const skuElementB = data.appContainer.querySelector(`[data-key="${b.key}"]`) || data.appContainer.querySelector(`[nested-id="${b.key}"]`);
            const containerA = skuElementA.closest(".we-products-container");
            const containerB = skuElementB.closest(".we-products-container");
            return containerPrio.get(containerA) - containerPrio.get(containerB);
        });
        for (const item of data.selectedProducts) {
            const tr = document.createElement("tr");
            const tdTitle = document.createElement("td");
            tdTitle.style.padding = "8px";
            const skuElement = data.appContainer.querySelector(`[data-key="${item.key}"]`) || data.appContainer.querySelector(`[nested-id="${item.key}"]`);
            const container = skuElement ? skuElement.closest(".we-products-container") : createContainer();
            if(alreadyAdded.has(container)) continue;
            let containerTitle = container.getAttribute("data-container-title");
            if(!containerTitle){
                containerTitle = data.productMap[item.key].title;
            }
            
            tdTitle.textContent = containerTitle;
            tr.appendChild(tdTitle);
            const tdPrice = document.createElement("td");
            tdPrice.style.padding = "8px";
            tdPrice.style.textAlign = "right";
            const price = Array.from(container.querySelectorAll(":scope > .we-product-item[data-selected]")).reduce((acc, product) =>{
                return acc + data.productMap[product.getAttribute("data-key") || product.getAttribute("nested-id")].price
            }, 0);
            // if(alreadyAdded[container]) continue;
            // const price = data.productMap[sku].price;
            tdPrice.textContent = formatPriceWithComma(price);
            tr.appendChild(tdPrice);
            priceTableBody.appendChild(tr);
            alreadyAdded.set(container,true);
        }
        let total = data.selectedProducts.reduce((acc, item) =>{
            return acc + data.productMap[item.key].price
        }, 0);
        total += data.currentProduct.price;
        const totalPriceElement = data.priceTable.querySelector(".we-conf-price-table-total");
        totalPriceElement.textContent = formatPriceWithComma(total);
        data.bottomBar.querySelector(".we-bottom-bar-price").textContent = formatPriceWithComma(total);
        
        // Update PDP price element
        updatePdpPrice(total);
        
        if(data.selectedProducts.length > 0){
            data.priceTable.classList.remove("we-hide");
        }else{
            data.priceTable.classList.add("we-hide");
        }
    }

    function updatePdpPrice(totalPrice) {
        if (!data.pdpPriceElement) return;
        
        // Clear existing content
        data.pdpPriceElement.innerHTML = "";
        
        // Add visually hidden span
        const visuallyHiddenSpan = document.createElement("span");
        visuallyHiddenSpan.className = "visually-hidden";
        visuallyHiddenSpan.textContent = "Angebotspreis";
        data.pdpPriceElement.appendChild(visuallyHiddenSpan);
        
        // Add the total price
        const priceText = document.createTextNode(formatPriceWithComma(totalPrice));
        data.pdpPriceElement.appendChild(priceText);
    }

    function initializeBottomBarPrice() {
        if (!data.bottomBar) return;
        
        const bottomBarPriceElement = data.bottomBar.querySelector(".we-bottom-bar-price");
        if (bottomBarPriceElement) {
            bottomBarPriceElement.textContent = formatPriceWithComma(data.currentProduct.price);
        }
    }

    function handleProductItemClick(productItem){
        const nestedId = productItem.getAttribute("nested-id");
        const isDisabled = productItem.classList.contains("we-disabled");
        if(isDisabled) return;
        if(nestedId){
            const sectionData = data.sectionCountMap[nestedId];
            const firstSelectedItem = sectionData.products_container.querySelector(".we-product-item[data-selected]");
            const nestedWrapper = document.querySelector(`#${nestedId}`);
            const isOpen = nestedWrapper && toggleNestedWrapper(nestedWrapper);
            const isProduct = productItem.hasAttribute("is-product");
            toggleProductCheckbox(productItem,isOpen);
            if(isOpen === false){
                    removeNestedSelectedItems(nestedId);
                if(isProduct){
                    data.selectedProducts = data.selectedProducts.filter(item => item.key !== productItem.getAttribute("data-key"));
                    data.selectedProducts = data.selectedProducts.filter(item => item.key !== productItem.getAttribute("nested-id"));
                }
            } else if(isOpen === true){
                if(isProduct){
                    const productKey = productItem.getAttribute("data-key") || productItem.getAttribute("nested-id");
                    const product = data.productMap[productKey];
                    const item = {
                        variantId: product.variants[0].id,
                        key: productItem.getAttribute("data-key") || productItem.getAttribute("nested-id"),
                    }
                    data.selectedProducts.push(item);
                }
            } else{
                //Product label group with no products
                const isSelected = productItem.hasAttribute("data-selected");
                if(isSelected){
                    const productKey = productItem.getAttribute("data-key") || productItem.getAttribute("nested-id");
                    const product = data.productMap[productKey];
                    const item = {
                        variantId: product.variants[0].id,
                        key: productItem.getAttribute("data-key") || productItem.getAttribute("nested-id"),
                    }
                    data.selectedProducts.push(item);
                } else{
                    data.selectedProducts = data.selectedProducts.filter(item => item.key !== productItem.getAttribute("data-key"));
                    data.selectedProducts = data.selectedProducts.filter(item => item.key !== productItem.getAttribute("nested-id"));
                }
            }
            const max = sectionData.max;
            if(!max) return;
            const maxNumber = parseInt(max);
            const count = sectionData.products_container.querySelectorAll(":scope > .we-product-item[data-selected]").length;

            if(count == maxNumber){
                const allItems = sectionData.products_container.querySelectorAll(":scope > .we-product-item");
                allItems.forEach(item => {
                    if(!item.hasAttribute("data-selected")){
                        item.classList.add("we-disabled");
                    }
                });
            } else{
                const allItems = sectionData.products_container.querySelectorAll(":scope > .we-product-item");
                allItems.forEach(item => {
                    item.classList.remove("we-disabled");
                });
            }
            return;
        }

        const sku = productItem.getAttribute("data-sku");
        if(!sku) return;


        const isSelected = productItem.hasAttribute("data-selected");
        const sectionKey = productItem.getAttribute("data-key");
        const sectionData = data.sectionCountMap[sectionKey];

        const countSelectedProducts = () =>{
            //Selects all direct children of the products container that are selected and returns the length of the array
            return sectionData.products_container.querySelectorAll(":scope > .we-product-item[data-selected]").length;
        }
        if(isSelected){
            data.selectedProducts = data.selectedProducts.filter(item => item.variantId !== sku);
            productItem.removeAttribute("data-selected");
            toggleProductCheckbox(productItem,!isSelected);
            if(sectionData.countNumber){
                sectionData.countNumber.textContent = countSelectedProducts();
            }
            const allDisabled = sectionData.products_container.querySelectorAll(":scope > .we-disabled");
            allDisabled.forEach(item => {
                item.classList.remove("we-disabled");
            });
            return;
        }else{
            const count = countSelectedProducts() + 1
            const max = sectionData.max;
            const min = sectionData.min ? parseInt(sectionData.min) : 0;
            
            // Special case: if min<=1 and max=1, allow only one selection (radio button behavior)
            if(min <= 1 && max && parseInt(max) == 1){
                // Remove any previously selected item
                const previouslySelected = sectionData.products_container.querySelector(":scope > .we-product-item[data-selected]");
                if(previouslySelected){
                    const prevSku = previouslySelected.getAttribute("data-sku");
                    data.selectedProducts = data.selectedProducts.filter(item => item.variantId !== prevSku);
                    previouslySelected.removeAttribute("data-selected");
                    toggleProductCheckbox(previouslySelected, false);
                }
            } else if(max && count > parseInt(max)){
                if(min == 1){
                    const firstItem = sectionData.products_container.querySelector(":scope > .we-product-item[data-selected]");
                    if(firstItem){
                        const sku = firstItem.getAttribute("data-key");
                        data.selectedProducts = data.selectedProducts.filter(item => item.key !== sku);
                        firstItem.removeAttribute("data-selected");
                        toggleProductCheckbox(firstItem,false);
                    }
                } else {
                    const allDisabled = Array.from(sectionData.products_container.querySelectorAll(":scope > .we-product-item:not([data-selected])"));
                    const allDisabledWithoutFirst = allDisabled.filter(item => item !== productItem);
                    allDisabledWithoutFirst.forEach(item => {
                        item.classList.add("we-disabled");
                    });
                }
                return; // Prevent adding the item when max limit is exceeded
            }
            const item = {
                variantId: sku,
                key: sectionKey,
            }
            data.selectedProducts.push(item);
            productItem.setAttribute("data-selected","");
            toggleProductCheckbox(productItem,!isSelected);
            if(sectionData.countNumber){
                sectionData.countNumber.textContent = countSelectedProducts();
            }
            
            // Disable other items if max limit is reached (but not for min<=1, max=1 case)
            if(max && countSelectedProducts() >= parseInt(max) && !(min <= 1 && parseInt(max) == 1)){
                const allItems = sectionData.products_container.querySelectorAll(":scope > .we-product-item");
                allItems.forEach(item => {
                    if(!item.hasAttribute("data-selected")){
                        item.classList.add("we-disabled");
                    }
                });
            }
        }
        
    }

    function getErrorHTML(){
        const errorContainer = document.createElement("div");
        errorContainer.classList.add("we-error-container");
        errorContainer.innerHTML = `
            <h2>Folgende Fehler beim konfigurieren:</h2>
            <ul>
                ${data.errors.map(error => `<li>${error.message}</li>`).join("")}
            </ul>
        `
        return errorContainer;
    }

    function handleAtcButtonClick(){
        addToProductForm(data.productForm, data.selectedProducts.map(item => item.variantId));
        data.productForm.requestSubmit();
        
    }

    function handleShowMoreLinkClick(showMoreLink){
        const popupKey = showMoreLink.getAttribute("popup-key");
        const popupData = data.popupMap[popupKey];
        const variantenbilder = data.variantenbilderMap[popupKey] || [];
        if(!popupData && variantenbilder.length <= 0) return;

        if(showMoreLink.hasAttribute("has-product")){
            const product = data.productMap[showMoreLink.getAttribute("data-sku")] || data.productMap[showMoreLink.getAttribute("popup-key")];
            const popup = {
                title: product.title,
                text: product.description,
                image: product.featured_image,
            }
            showPopup(popup,variantenbilder);
            return;
        }
        if (popupData.text) {
            const parser = new DOMParser();
            decodedString = parser.parseFromString(popupData.text, "text/html").documentElement.textContent || "";
            popupData.text = decodedString;
        }
        showPopup(popupData,variantenbilder);
        
    }

    function createContainer(){
        const container = document.createElement("div");
        container.classList.add("we-products-container");
        return container;
    }

    //Returns true if the nested wrapper is open after the toggle, false otherwise
    function toggleNestedWrapper(nestedWrapper){
        const isOpen = nestedWrapper.classList.contains("grow");
        if(isOpen){
            nestedWrapper.classList.remove("grow");
            nestedWrapper.removeAttribute("open");
            return false;
        }else{
            nestedWrapper.classList.add("grow");
            nestedWrapper.setAttribute("open","");
            return true;
        }
    }

    //Toggles the checkbox of the product item
    function toggleProductCheckbox(productItem,isOpen){
        const checkedSvg = productItem.querySelector(".we-checked");
        const uncheckedSvg = productItem.querySelector(".we-unchecked");
       if(isOpen === true){
        checkedSvg.classList.remove("we-hide");
        uncheckedSvg.classList.add("we-hide");
        productItem.setAttribute("data-selected","");
       }else if(isOpen === false){
        checkedSvg.classList.add("we-hide");
        uncheckedSvg.classList.remove("we-hide");
        productItem.removeAttribute("data-selected");
       } else{
        const isSelected = productItem.hasAttribute("data-selected");
        if(isSelected){
            toggleProductCheckbox(productItem,false);
        } else{
            toggleProductCheckbox(productItem,true);
        }
       }
    }

    //Toggles the configurator wrapper and nested wrapper
    function toggleConfigurator(configuratorWrapper){
        const firstNestedWrapper = configuratorWrapper.querySelector(".we-nested-wrapper");
        const isOpen = firstNestedWrapper.classList.contains("grow");
        if(isOpen){
            firstNestedWrapper.classList.remove("grow");
            const getPlusButton = configuratorWrapper.querySelector(".we-configurator-title svg path:nth-child(2)");
            getPlusButton.style.transform = "rotate(0deg)";
        }else{
            firstNestedWrapper.classList.add("grow");
            const getPlusButton = configuratorWrapper.querySelector(".we-configurator-title svg path:nth-child(2)");
            getPlusButton.style.transform = "rotate(90deg)";
        }
    }

    function removeNestedSelectedItems(nestedId){
        const nestedWrapper = data.appContainer.querySelector(`#${nestedId}`);
        const allSelectedItems = nestedWrapper.querySelectorAll(".we-product-item[data-selected]");
        allSelectedItems.forEach(item => {
            item.removeAttribute("data-selected");
            toggleProductCheckbox(item,false);
            data.selectedProducts = data.selectedProducts.filter(innerItem => innerItem.key !== item.getAttribute("data-key"));
        });
        const countNumbers = nestedWrapper.querySelectorAll(".we-count-number");
        countNumbers.forEach(number => {
            number.textContent = 0;
        });
    }

    function getSvgHTML(){
        return `
            <div style="width: 24px; height: 24px; position: relative; transition: transform 0.3s;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" style="display: block;">
                        <path d="M5 12H19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="transition: all 0.3s ease; transform-origin: center;"></path>
                        <path d="M12 5V19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="transition: 0.3s; transform-origin: center center; transform: rotate(0deg); opacity: 1;"></path>
                    </svg>
            </div>
            `
    }

    function mergeContainers(configuratorGroupDataFinal){
        return configuratorGroupDataFinal.reduce((acc, item) => {
            const existingItem = acc.find(innerItem => innerItem.container === item.container);
            if(existingItem){
                existingItem.nestedProducts = existingItem.nestedProducts || [existingItem.products];
                existingItem.nestedProducts.push(item.products);
                existingItem.items = existingItem.items || [existingItem];
                existingItem.items.push(item);
                return acc;
            }
            return [...acc, item];
        }, []);
    }

    function scrollToProductItem(productItem){
        const productItemRect = productItem.getBoundingClientRect();
        const productItemOffset = productItemRect.top - 100 + window.scrollY;
        window.scrollTo({
            top: productItemOffset,
            behavior: 'smooth'
        });
    }

    function scrollToTop(){
        const appContainerRect = data.appContainer.getBoundingClientRect();
        const appContainerOffset = appContainerRect.top + window.scrollY;
        window.scrollTo({
            top: appContainerOffset,
        });
    }

    //Fills elementContainer with the products of the sectionData
    function fillProducts(sectionData,elementContainer, nestedWrapper,noNested){
        if(sectionData.products.length <= 0){
            return;
        }

        const configuratorSection = document.createElement("div");
        configuratorSection.classList.add("configurator-group");
        const title = document.createElement("span");
        title.classList.add("configurator-group-title");
        title.textContent = sectionData.title || sectionData.container;
        configuratorSection.appendChild(title);

        if(sectionData.labelType !== "checkbox" && sectionData.max !== null){
            const countSection = document.createElement("div");
            countSection.classList.add("we-count-section");
            const spanOpenParenthesis = document.createElement("span");
            spanOpenParenthesis.innerHTML = "(";
            const spanCount = document.createElement("span");
            spanCount.classList.add("we-count-number");
            spanCount.textContent = 0;
            const spanCloseParenthesis = document.createElement("span");
            spanCloseParenthesis.innerHTML = `/${sectionData.max})`;
            const infoText = document.createElement("span");
            infoText.classList.add("we-count-info");
            if(sectionData.min > 0){
                let selectText = "";
                let minText = "";
                let productTextSingular = "";
                let productTextPlural = "";
                let a = ""
                if(shopLocale === "de"){
                    selectText = "Wähle";
                    minText = "mindestens";
                    productTextPlural = "Produkte";
                    productTextSingular = "Produkt";
                    a = "ein";
                } else if(shopLocale === "en"){
                    selectText = "Choose";
                    minText = "at least";
                    productTextPlural = "products";
                    productTextSingular = "product";
                    a = "a";
                }
                infoText.innerHTML = `${selectText} ${sectionData.min === 1 ? a + " " + productTextSingular : minText + " " + sectionData.min + " " + productTextPlural}`;
            } else if(sectionData.min === 0){
                infoText.innerHTML = configuratorData.choose_optional;
            }

            countSection.appendChild(spanOpenParenthesis);
            countSection.appendChild(spanCount);
            countSection.appendChild(spanCloseParenthesis);
            countSection.appendChild(infoText);
            title.appendChild(countSection);
        } else if(sectionData.labelType === "checkbox"){
            const infoText = document.createElement("span");
            infoText.classList.add("we-count-info");
            if(sectionData.min === 1 && sectionData.max === 1){
                infoText.innerHTML = configuratorData.required_text;
            } else if(sectionData.min === 0){
                infoText.innerHTML = configuratorData.choose_optional;
            }
            title.appendChild(infoText);
        }

        const productsContainer = document.createElement("div");
        productsContainer.classList.add("we-products-container");
        const newTitle = sectionData.title || sectionData.container || sectionData.handle || '';
        productsContainer.setAttribute("data-container-title",newTitle);
        productsContainer.setAttribute("id",`we-container-${newTitle.replace(" - ","-").replace(" ","-").toLowerCase()}`);
        if(sectionData.min !== null){
            productsContainer.setAttribute("data-min",sectionData.min);
        }
        if(sectionData.allowMultiple === "false"){
            productsContainer.setAttribute("data-max", 1);
        }
        if(sectionData.max !== null){
            productsContainer.setAttribute("data-max",sectionData.max);
        }
        if(noNested){
            productsContainer.classList.add("we-no-nested");
        }
        configuratorSection.appendChild(productsContainer);


        sectionData.products.forEach(product => {
            const uniqueId = generateUniqueId();
            const productItemElement = getProductItemElement(product, uniqueId);
            if(sectionData.labelType === "checkbox"){
                productItemElement.setAttribute("nested-id", uniqueId);
            }
            productsContainer.appendChild(productItemElement);
            //If the product has nested items, create a nested wrapper and call fillProducts recursively
            if(product.nestedItems.length > 0){
                const nestedWrapper = document.createElement("div");
                nestedWrapper.classList.add("we-nested-wrapper");
                nestedWrapper.setAttribute("id", uniqueId);
                
                const nestedWrapperContainer = document.createElement("div");
                nestedWrapperContainer.classList.add("we-nested-wrapper-container")
                nestedWrapper.appendChild(nestedWrapperContainer);
                product.nestedItems.forEach(nestedSection => {
                    const noNested = false;
                    data.containerTitleMap[nestedSection.title] = `we-container-${sectionData.title.replace(" - ","-").replace(" ","-").toLowerCase()}`;
                    fillProducts(nestedSection,nestedWrapperContainer,null,noNested);
                })
                productsContainer.appendChild(nestedWrapper);
            }

            if(product.popup){
                data.popupMap[uniqueId] = product.popup;
            }

            if(product.variantenbilder){
                data.variantenbilderMap[uniqueId] = product.variantenbilder;
            }

            const max = sectionData.max !== null ? sectionData.max : sectionData.allowMultiple === "false" ? 1 : null;

            data.sectionCountMap[uniqueId] = {
                min: sectionData.min,
                max: max,
                products_container: productsContainer,
                countNumber: title.querySelector(".we-count-number")
            };

            if(product.sku){
                if(data.productMap[uniqueId]){
                    if(sectionData.title === null){
                        console.error("sectionData",sectionData);
                    }
                    data.errors.push(
                        {
                            product: product,
                            containerTitle: sectionData.title,
                            message: `Produkt ${product.title} in "${sectionData.title}" ist bereits in der Gruppe "${data.productMap[uniqueId].title}" enthalten.`
                        }
                    );
                } else {
                    data.productMap[uniqueId] = product;
                    data.productMap[uniqueId].key = uniqueId;
                }
                
            }
            
        });


        if(nestedWrapper){
            nestedWrapper.appendChild(configuratorSection);
            elementContainer.appendChild(nestedWrapper);
        }else{
            elementContainer.appendChild(configuratorSection);
        }

        return elementContainer;
    }

    function addToProductForm(form, skus) {
        const arrSkus = Array.from(skus);
        const secretKey = generateUniqueId();
        const mainVariantInput = form.querySelector('[name="id"]');
        const mainVariantId = mainVariantInput.value;
        mainVariantInput.remove();

        const weAddedProduct = document.createElement('input');
        const lastIndex = arrSkus.length;
        weAddedProduct.type = 'hidden';
        weAddedProduct.name = 'items[' + lastIndex + '][id]';
        weAddedProduct.value = mainVariantId;
        form.appendChild(weAddedProduct);

        const weAddedProductProperty = document.createElement('input');
        weAddedProductProperty.type = 'hidden';
        weAddedProductProperty.name = 'items[' + lastIndex + '][properties][_secret_parent]';
        weAddedProductProperty.value = secretKey;

        form.appendChild(weAddedProductProperty);
        arrSkus.forEach((sku,index) => {
            const weAddedProduct = document.createElement('input');
            weAddedProduct.type = 'hidden';
            weAddedProduct.name = 'items[' + index + '][id]';
            weAddedProduct.classList.add('we-added-product');
            weAddedProduct.value = sku;
            form.appendChild(weAddedProduct);

            const weAddedProperty = document.createElement('input');
            weAddedProperty.type = 'hidden';
            weAddedProperty.name = 'items[' + index + '][properties][_secret]';
            weAddedProperty.value = secretKey;
            form.appendChild(weAddedProperty);

            const weAddedPropertyParentTitel = document.createElement('input');
            weAddedPropertyParentTitel.type = 'hidden';
            weAddedPropertyParentTitel.name = 'items[' + index + '][properties][Hauptprodukt]';
            weAddedPropertyParentTitel.value = data.currentProduct.title;
            form.appendChild(weAddedPropertyParentTitel);
        });
    }

    function getProductItemElement(product, uniqueId){
        const productItem = document.createElement('div');
        productItem.className = 'we-product-item';
        if(product.sku){
            productItem.setAttribute("data-sku", product.sku);
            productItem.setAttribute("data-key", uniqueId);
        }
        if(product.product){
            productItem.setAttribute("is-product", "");
            data.productMap[uniqueId] = product.product;
            productItem.setAttribute("data-sku", product.product.variants[0].id);
        }
        const productImage = document.createElement('div');
        productImage.className = 'product-image';

        if(product.product){
            const img = document.createElement('img');
            img.src = product.product.featured_image;
            img.alt = product.product.title;
            productImage.appendChild(img);
        } else if(product.image){
            const img = document.createElement('img');
            img.src = product.image;
            img.alt = product.title;
            productImage.appendChild(img);
        }

        const productContent = document.createElement('div');
        productContent.className = 'product-content';

        const productText = document.createElement('div');
        productText.className = 'product-text';

        const h4 = document.createElement('span');
        h4.classList.add("h4");
   
        if(product.product){
            h4.textContent = product.product.title;
        }else{
            h4.textContent = product.title;
        }

        // const hideDescription = h4.textContent.length <= 31;

        
        const showMoreLink = document.createElement('button');
        showMoreLink.type = 'button';
        showMoreLink.className = 'we-show-more-link';
        showMoreLink.textContent = configuratorData.open_configure_popup_text;
        showMoreLink.setAttribute("popup-key", uniqueId);
        if(product.product){
            showMoreLink.setAttribute("has-product", "");
            showMoreLink.setAttribute("data-sku", product.product.variants[0].id);
        }

        productText.appendChild(h4);
        
        if(product.product){
            const desc = document.createElement('div');
            desc.classList.add("we-product-desc");
            // desc.innerHTML = hideDescription ? product.product.description : "";
            desc.appendChild(showMoreLink);
            productText.appendChild(desc);
            
        } else if(product.desc){
            const desc = document.createElement('p');
            // desc.innerHTML = hideDescription ? product.desc : "";
            desc.classList.add("we-product-desc");
            desc.appendChild(showMoreLink);
            productText.appendChild(desc);
        } else {
            productText.appendChild(showMoreLink);
        }

        if(product.product){
            const price = document.createElement('p');
            price.textContent = product.product.price ? formatPriceWithComma(product.product.price) : product.product.priceText;
            price.classList.add("we-product-price");
            productText.appendChild(price);
        } else if(product.price){
            const price = document.createElement('p');
            price.textContent = formatPriceWithComma(product.price);
            price.classList.add("we-product-price");
            productText.appendChild(price);
        } else if(product.priceText){
            const price = document.createElement('p');
            price.textContent = product.priceText;
            price.classList.add("we-product-price");
            productText.appendChild(price);
        } else if (product.sku) {
            const price = document.createElement('p');
            price.classList.add("we-product-price");
            price.textContent = configuratorData.price_included_text;
            productText.appendChild(price);
        }

        const productControl = document.createElement('div');
        productControl.className = 'product-control';

        const checkboxContainer = document.createElement('div');
        checkboxContainer.className = 'we-checkbox-container';
        checkboxContainer.style.cursor = 'pointer';

        const uncheckedSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        uncheckedSvg.setAttribute('class', 'we-unchecked');
        uncheckedSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        uncheckedSvg.setAttribute('width', '16');
        uncheckedSvg.setAttribute('height', '16');
        uncheckedSvg.setAttribute('viewBox', '0 0 16 16');
        uncheckedSvg.setAttribute('fill', 'none');

        const uncheckedPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        uncheckedPath.setAttribute('d', 'M8 15.75C3.7194 15.75 0.25 12.2806 0.25 8C0.25 3.7194 3.7194 0.25 8 0.25C12.2806 0.25 15.75 3.7194 15.75 8C15.75 12.2806 12.2806 15.75 8 15.75Z');
        uncheckedPath.setAttribute('fill', 'white');
        uncheckedPath.setAttribute('stroke', '#808080');
        uncheckedPath.setAttribute('stroke-width', '0.5');
        uncheckedPath.setAttribute('stroke-linecap', 'round');
        uncheckedPath.setAttribute('stroke-linejoin', 'round');
        uncheckedSvg.appendChild(uncheckedPath);

        const checkedSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        checkedSvg.setAttribute('class', 'we-checked');
        checkedSvg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        checkedSvg.setAttribute('width', '17');
        checkedSvg.setAttribute('height', '16');
        checkedSvg.setAttribute('viewBox', '0 0 17 16');
        checkedSvg.setAttribute('fill', 'none');
        checkedSvg.classList.add("we-hide");

        const checkedPath1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        checkedPath1.setAttribute('fill-rule', 'evenodd');
        checkedPath1.setAttribute('clip-rule', 'evenodd');
        checkedPath1.setAttribute('d', 'M8.8823 16C4.39865 16 0.764648 12.4187 0.764648 8C0.764648 3.58133 4.39865 0 8.8823 0C13.3659 0 16.9999 3.58133 16.9999 8C16.9999 12.4187 13.3659 16 8.8823 16Z');
        checkedPath1.setAttribute('fill', '#0E1E2D');

        const checkedPath2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        checkedPath2.setAttribute('fill-rule', 'evenodd');
        checkedPath2.setAttribute('clip-rule', 'evenodd');
        checkedPath2.setAttribute('d', 'M12.4901 6.22223L7.9803 10.6667L5.27441 8.00001');
        checkedPath2.setAttribute('fill', '#0E1E2D');

        const checkedPath3 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        checkedPath3.setAttribute('d', 'M12.4901 6.22223L7.9803 10.6667L5.27441 8.00001');
        checkedPath3.setAttribute('stroke', 'white');
        checkedPath3.setAttribute('stroke-width', '1.5');
        checkedPath3.setAttribute('stroke-linecap', 'round');
        checkedPath3.setAttribute('stroke-linejoin', 'round');

        checkedSvg.appendChild(checkedPath1);
        checkedSvg.appendChild(checkedPath2);
        checkedSvg.appendChild(checkedPath3);

        checkboxContainer.appendChild(uncheckedSvg);
        checkboxContainer.appendChild(checkedSvg);
        productControl.appendChild(checkboxContainer);

        productContent.appendChild(productText);
        productContent.appendChild(productControl);

        productItem.appendChild(productImage);
        productItem.appendChild(productContent);

        return productItem;
    }

    function formatPriceWithComma(cents) {
        const amount = cents / 100;

        // Use the German locale ('de-DE') which uses '.' for thousands
        // and ',' for the decimal separator.
        const formattedAmount = new Intl.NumberFormat('de-DE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount);

        return `€${formattedAmount}`;
      }

    function generateUniqueId(length = 12) {
        // Create a new array of the specified length.
        const buffer = new Uint8Array(length);
        // Fill the array with cryptographically strong random values.
        window.crypto.getRandomValues(buffer);
        
        // Define the characters to use in the ID.
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_-';
        let result = '';
        
        // Build the result string by mapping each random byte to a character.
        for (let i = 0; i < length; i++) {
          result += chars.charAt(buffer[i] % chars.length);
        }
        
        return "we-" + result;
      }

      // Method to display the popup
      function showPopup(popupData, variantenbilder) {
        // -- Easy-to-edit constant for image aspect ratio
        const IMAGE_ASPECT_RATIO = '4 / 3'; // Examples: '16 / 9', '4 / 3', '1 / 1'
    
        // --- Prerequisites Check ---
        if (typeof Swiper === 'undefined' && variantenbilder && variantenbilder.length > 0) {
            console.error("Swiper library is not loaded. Please include Swiper.js to use the image slider feature.");
        }
        
        // --- Basic Popup Setup (same as before) ---
        const existingPopup = document.getElementById('configurator-popup-overlay');
        if (existingPopup) {
            existingPopup.remove();
        }
    
        const overlay = document.createElement('div');
        overlay.id = 'configurator-popup-overlay';
        // ... (rest of overlay styling is the same)
        overlay.style.position = 'fixed';
        overlay.style.top = '0';
        overlay.style.left = '0';
        overlay.style.width = '100%';
        overlay.style.height = '100%';
        overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
        overlay.style.display = 'flex';
        overlay.style.justifyContent = 'center';
        overlay.style.alignItems = 'center';
        overlay.style.zIndex = '1000';
    
    
        const popup = document.createElement('div');
        popup.id = 'configurator-popup-content';
        // ... (rest of popup styling is the same)
        popup.style.backgroundColor = 'white';
        popup.style.borderRadius = '8px';
        popup.style.maxWidth = '720px';
        popup.style.position = 'relative';
        popup.classList.add("we-popup-animation");

        // Create inner container for content
        const popupInnerContainer = document.createElement('div');
        popupInnerContainer.className = 'popup-inner-container-content';
        popupInnerContainer.style.maxHeight = '500px';
        popupInnerContainer.style.overflowY = 'auto';
    
        const popupHeader = document.createElement('div');
        popupHeader.className = 'we-popup-header';
        // ... (header content setup is the same)
        const closeButton = getCloseButtonElement(); // Assuming getCloseButtonElement() exists
        const titleElement = document.createElement('h4');
        titleElement.textContent = popupData.title || 'Details';
        titleElement.style.marginTop = '0';
    
        popupHeader.appendChild(titleElement);
        popupHeader.appendChild(closeButton);
    
    
        // --- MODIFIED: Conditional Image Handling ---
        let imageContainer = null;
    
        if (variantenbilder && Array.isArray(variantenbilder) && variantenbilder.length > 0) {
            // --- 1. Swiper Slider Logic ---
            imageContainer = document.createElement('div');
            imageContainer.className = 'swiper popup-swiper-container';
            imageContainer.style.marginBottom = '32px';
            imageContainer.style.marginInline = '40px';
    
            const swiperWrapper = document.createElement('div');
            swiperWrapper.className = 'swiper-wrapper';

            const swiperSlide = document.createElement('div');
            swiperSlide.className = 'swiper-slide';
            swiperSlide.style.aspectRatio = IMAGE_ASPECT_RATIO;

            const imageElement = document.createElement('img');
            imageElement.src = popupData.image;;
            imageElement.alt = popupData.title || 'Variant Image';
            // **CHANGE**: Make image fill the container and use object-fit
            imageElement.style.width = '100%';
            imageElement.style.height = '100%';
            imageElement.style.objectFit = 'cover'; // Ensures image fits without distortion

            swiperSlide.appendChild(imageElement);
            swiperWrapper.appendChild(swiperSlide);

    
            variantenbilder.forEach(imageUrl => {
                const swiperSlide = document.createElement('div');
                swiperSlide.className = 'swiper-slide';
                // **CHANGE**: Set a fixed aspect ratio on the slide itself
                swiperSlide.style.aspectRatio = IMAGE_ASPECT_RATIO;
                swiperSlide.style.backgroundColor = '#f0f0f0'; // Optional: background for letterboxing
    
                const imageElement = document.createElement('img');
                imageElement.src = imageUrl;
                imageElement.alt = popupData.title || 'Variant Image';
                // **CHANGE**: Make image fill the container and use object-fit
                imageElement.style.width = '100%';
                imageElement.style.height = '100%';
                imageElement.style.objectFit = 'cover'; // Ensures image fits without distortion
    
                swiperSlide.appendChild(imageElement);
                swiperWrapper.appendChild(swiperSlide);
            });
    
            const nextButton = document.createElement('div');
            nextButton.className = 'swiper-button-next';
            const prevButton = document.createElement('div');
            prevButton.className = 'swiper-button-prev';
            const pagination = document.createElement('div');
            pagination.className = 'swiper-pagination';
    
            imageContainer.appendChild(swiperWrapper);
            imageContainer.appendChild(nextButton);
            imageContainer.appendChild(prevButton);
            imageContainer.appendChild(pagination);
    
        } else if (popupData.image) {
            // --- 2. Fallback to Original Single Image Logic ---
            imageContainer = document.createElement('div');
            imageContainer.className = 'popup-image-container';
            imageContainer.style.marginBottom = '32px';
            // **CHANGE**: Set a fixed aspect ratio on the container
            imageContainer.style.aspectRatio = IMAGE_ASPECT_RATIO;
            imageContainer.style.backgroundColor = '#f0f0f0'; // Optional: background for letterboxing
    
            const imageElement = document.createElement('img');
            imageElement.src = popupData.image;
            imageElement.alt = popupData.title || 'Popup Image';
            // **CHANGE**: Make image fill the container and use object-fit
            imageElement.style.width = '100%';
            imageElement.style.height = '100%';
            imageElement.style.objectFit = 'cover'; // Ensures image fits without distortion
            
            imageContainer.appendChild(imageElement);
        }
    
        // --- Popup Assembly and Teardown (same as before) ---
        const textElement = document.createElement('p');
        textElement.classList.add('popup-description');
        // let decodedString = "";
        // if (popupData.text) {
        //     const parser = new DOMParser();
        //     decodedString = parser.parseFromString(popupData.text, "text/html").documentElement.textContent || "";
        // }
        // textElement.innerHTML = decodedString;
        textElement.innerHTML = popupData.text;
    
        const contactElement = getWeContact(); // Assuming getWeContact() exists
    
        popup.appendChild(popupHeader);
        if (imageContainer) {
            popupInnerContainer.appendChild(imageContainer);
        }
        popupInnerContainer.appendChild(textElement);
        popupInnerContainer.appendChild(contactElement);
        popup.appendChild(popupInnerContainer);
        overlay.appendChild(popup);
        document.body.appendChild(overlay);
    
        // --- Initialize Swiper IF it was created ---
        if (variantenbilder && Array.isArray(variantenbilder) && variantenbilder.length > 0) {
            new Swiper('.popup-swiper-container', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                pagination: { el: '.swiper-pagination', clickable: true },
                navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
            });
        }
    
        // --- Close Handlers (same as before) ---
        const closePopup = () => {
            // Restore body scrolling
            document.body.style.overflow = '';
            overlay.remove();
        };
        
        // Disable body scrolling when popup opens
        document.body.style.overflow = 'hidden';
        
        closeButton.addEventListener('click', closePopup);
        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                closePopup();
            }
        });
    }

    function createBottomBar(){
    const bottomBar = document.createElement('div');
    bottomBar.classList.add('we-bottom-bar');

    const text = document.createElement('p');
    text.textContent = configuratorData.bottom_nav_text + ": ";
    
    const price = document.createElement('span');
    price.classList.add('we-bottom-bar-price');
    price.textContent = "€0,00";
    text.appendChild(price);
    
    bottomBar.appendChild(text);

    const atcButton = document.createElement('button');
    atcButton.classList.add('we-bottom-bar-atc-button');
    atcButton.classList.add('button');
    atcButton.classList.add('button--primary');
    atcButton.classList.add('we-conf-disabled');
    atcButton.textContent = configuratorData.bottom_nav_atc;
    bottomBar.appendChild(atcButton);

    return bottomBar;
    }

    function renderPriceTable(){
        const table = document.createElement('table');
        table.className = 'we-conf-price-table';
        table.classList.add("we-hide");
        table.style.width = '100%';
        table.style.marginTop = '15px';
        table.style.borderCollapse = 'collapse';

        const thead = document.createElement('thead');
        const headerRow = document.createElement('tr');
        
        const summaryHeader = document.createElement('th');
        summaryHeader.style.textAlign = 'left';
        summaryHeader.style.borderBottom = '1px solid #ccc';
        summaryHeader.style.padding = '8px';
        summaryHeader.textContent = configuratorData.summary_title;
        
        const totalHeader = document.createElement('th');
        totalHeader.style.textAlign = 'right';
        totalHeader.style.borderBottom = '1px solid #ccc';
        totalHeader.style.padding = '8px';
        totalHeader.textContent = configuratorData.total_price;

        headerRow.appendChild(summaryHeader);
        headerRow.appendChild(totalHeader);
        thead.appendChild(headerRow);

        const tbody = document.createElement('tbody');
        tbody.className = 'we-conf-price-table-body';

        const tfoot = document.createElement('tfoot');
        const footerRow = document.createElement('tr');
        
        const totalLabel = document.createElement('td');
        totalLabel.style.textAlign = 'left';
        totalLabel.style.borderTop = '1px solid #ccc';
        totalLabel.style.padding = '8px';
        totalLabel.style.fontWeight = 'bold';
        totalLabel.textContent = configuratorData.complete_price;

        const totalAmount = document.createElement('td');
        totalAmount.className = 'we-conf-price-table-total';
        totalAmount.style.textAlign = 'right';
        totalAmount.style.borderTop = '1px solid #ccc';
        totalAmount.style.padding = '8px';
        totalAmount.style.fontWeight = 'bold';
        totalAmount.textContent = '0 €';

        footerRow.appendChild(totalLabel);
        footerRow.appendChild(totalAmount);
        tfoot.appendChild(footerRow);

        table.appendChild(thead);
        table.appendChild(tbody);
        table.appendChild(tfoot);

        return table;
    }

    function getCloseButtonElement() {
        const closeButton = document.createElement('button');
        closeButton.className = 'we-modal-close';
    
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svg.setAttribute('width', '16');
        svg.setAttribute('height', '16'); 
        svg.setAttribute('viewBox', '0 0 16 16');
        svg.setAttribute('fill', 'none');
    
        const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path1.setAttribute('d', 'M1.6665 1L14.9998 14.3333');
        path1.setAttribute('stroke', '#1A1A1A');
        path1.setAttribute('stroke-width', '2');
        path1.setAttribute('stroke-linecap', 'round');
        path1.setAttribute('stroke-linejoin', 'round');
    
        const path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path2.setAttribute('d', 'M14.9998 1L1.6665 14.3333');
        path2.setAttribute('stroke', '#1A1A1A');
        path2.setAttribute('stroke-width', '2');
        path2.setAttribute('stroke-linecap', 'round');
        path2.setAttribute('stroke-linejoin', 'round');
    
        svg.appendChild(path1);
        svg.appendChild(path2);
        closeButton.appendChild(svg);
    
        return closeButton;
    }

    function getWeContact() {
        const contactElement = document.createElement('div');
        contactElement.className = 'we-contact';
    
        const innerDiv = document.createElement('div');
        
        const questionSpan = document.createElement('span');
        questionSpan.textContent = configuratorData.contact_questions_label;
        
        const promptP = document.createElement('p');
        promptP.textContent = configuratorData.contact_prompt_label;
        
        innerDiv.appendChild(questionSpan);
        innerDiv.appendChild(promptP);
    
        const contactLink = document.createElement('a');
        contactLink.className = 'we-contact-button';
        contactLink.href = '/pages/kontakt';
    
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svg.setAttribute('width', '19');
        svg.setAttribute('height', '20');
        svg.setAttribute('viewBox', '0 0 19 20');
        svg.setAttribute('fill', 'none');
    
        const path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path1.setAttribute('fill-rule', 'evenodd');
        path1.setAttribute('clip-rule', 'evenodd');
        path1.setAttribute('d', 'M12.4795 17.5417L17.9355 2.82169C18.2325 2.01969 17.4515 1.23969 16.6505 1.53669L1.92549 6.99669C1.00449 7.33869 1.07649 8.66469 2.02949 8.90369L8.86349 10.6207L10.5705 17.4367C10.8105 18.3907 12.1375 18.4637 12.4795 17.5417V17.5417Z');
        path1.setAttribute('stroke', '#1A1A1A');
        path1.setAttribute('stroke-width', '2');
        path1.setAttribute('stroke-linecap', 'round');
        path1.setAttribute('stroke-linejoin', 'round');
    
        const path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path2.setAttribute('d', 'M17.7055 1.76367L8.86548 10.6237');
        path2.setAttribute('stroke', '#1A1A1A');
        path2.setAttribute('stroke-width', '2');
        path2.setAttribute('stroke-linecap', 'round');
        path2.setAttribute('stroke-linejoin', 'round');
    
        svg.appendChild(path1);
        svg.appendChild(path2);
    
        const contactSpan = document.createElement('span');
        contactSpan.textContent = configuratorData.contact_url_label;
    
        contactLink.appendChild(svg);
        contactLink.appendChild(contactSpan);
    
        contactElement.appendChild(innerDiv);
        contactElement.appendChild(contactLink);
    
        return contactElement;
    }

    main(); 
})  